export default class ImageLinkTune {
  static get isTune() {
    return true;
  }

  constructor({ api, data, block }) {
    this.api = api;
    this.block = block;
    this.data = data || {};
    this.button = null;
  }

  render() {
    this.button = document.createElement('div');
    this.button.innerHTML = `
      <span class="image-link-icon" style="margin-right: 4px;">
        <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor"
          d="M3.9,12A5.1,5.1 0 0,1 9,6.9H11V5H9A7,7 0 0,0 2,12A7,7 0 0,0 9,19H11V17.1H9A5.1,5.1 0 0,1 3.9,12M15,5H13V6.9H15A5.1,5.1 0 0,1 20.1,12A5.1,5.1 0 0,1 15,17.1H13V19H15A7,7 0 0,0 22,12A7,7 0 0,0 15,5Z" />
        </svg>
      </span>
      <span class="image-link-label">Добави линк към изображението</span>`;
    this.button.classList.add('cdx-settings-button');
    this.button.title = 'Добави линк към изображението';

    this.button.addEventListener('click', () => {
      this.openLinkPopup();
    });

    return this.button;
  }

  openLinkPopup() {
    const popup = document.createElement('div');
    popup.className = 'image-link-popup';
    popup.style.cssText = `
      position: absolute;
      z-index: 9999;
      background: white;
      border: 1px solid #ccc;
      padding: 12px;
      border-radius: 6px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      font-family: sans-serif;
    `;

    const input = document.createElement('input');
    input.type = 'url';
    input.value = this.data.link || '';
    input.placeholder = 'https://example.com';
    input.style.cssText = 'width: 250px; padding: 6px; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 4px;';

    const feedback = document.createElement('div');
    feedback.style.cssText = 'font-size: 13px; color: red; margin-bottom: 8px;';

    const saveBtn = document.createElement('button');
    saveBtn.textContent = 'Запази';
    saveBtn.style.cssText = 'margin-right: 8px; background: #005aa0; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer;';

    const removeBtn = document.createElement('button');
    removeBtn.textContent = 'Премахни линка';
    removeBtn.style.cssText = 'margin-right: 8px; background: #f44336; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer;';

    const cancelBtn = document.createElement('button');
    cancelBtn.textContent = 'Затвори';
    cancelBtn.style.cssText = 'padding: 6px 12px; border-radius: 4px; border: 1px solid #ccc; cursor: pointer;';

    popup.appendChild(input);
    popup.appendChild(feedback);
    popup.appendChild(saveBtn);
    popup.appendChild(removeBtn);
    popup.appendChild(cancelBtn);
    document.body.appendChild(popup);

    // позициониране
    const rect = this.button.getBoundingClientRect();
    popup.style.top = `${rect.bottom + window.scrollY + 5}px`;
    popup.style.left = `${rect.left + window.scrollX}px`;

    input.focus();

    saveBtn.addEventListener('click', () => {
      const url = input.value.trim();
      if (!this.validateUrl(url.startsWith('http') ? url : 'https://' + url)) {
        feedback.textContent = 'Моля, въведи валиден URL (http:// или https://)';
        return;
      }
      this.data.link = /^https?:\/\//i.test(url) ? url : 'https://' + url;
      document.body.removeChild(popup);
    });

    removeBtn.addEventListener('click', () => {
      this.data.link = null;
      document.body.removeChild(popup);
    });

    cancelBtn.addEventListener('click', () => {
      document.body.removeChild(popup);
    });
  }

  validateUrl(url) {
    try {
      const u = new URL(url);
      return u.protocol === 'http:' || u.protocol === 'https:';
    } catch (_) {
      return false;
    }
  }

  save() {
    return this.data;
  }
}
